export default {
    buttons: {
        back: "Zurück",
        next: "Nächste",
        submit: "Einreichen"
    }
}